import Vue from 'vue'

import Router from 'vue-router'
Vue.use(Router)

// 创建一个路由器实例
// 并且配置路由规则
export default new Router({
  scrollBehavior(to, from, savedPosition) {
    const position = {}
    if (to.hash) {
      position.selector = to.hash
    } else {
      position.x = 0
      position.y = 0
    }
    return position
  },
  mode: 'history',
  base: __dirname,
  routes: [
    {
      name: 'shopCart',
      path: '/repair/shopping/shopCart', // 定制购物车
      component(resolve) {
        require(['../pages/shopping/shopCart.vue'], resolve)
      },
      meta: {
        title: '卡修宝典'
      }
    },
    {
      name: 'orderDetails',
      path: '/repair/questionsOrAnswers/orderDetails', // 问答v1.3
      component(resolve) {
        require(['../pages/questionsOrAnswers/orderDetails.vue'], resolve)
      },
      meta: {
        title: '接单'
      }
    },
    {
      name: 'qaAssistant',
      path: '/repair/questionsOrAnswers/qaAssistant', // 问答v1.3
      component(resolve) {
        require(['../pages/questionsOrAnswers/qaAssistant.vue'], resolve)
      },
      meta: {
        title: '问答小助手'
      }
    },
    {
      name: 'questionDetails',
      path: '/repair/questionsOrAnswers/questionDetails', // 问答v1.3
      component(resolve) {
        require(['../pages/questionsOrAnswers/questionDetails.vue'], resolve)
      },
      meta: {
        title: '问题详情'
      }
    },
    {
      name: 'conversationV13',
      path: '/repair/questionsOrAnswers/conversation', // 问答v1.3
      component(resolve) {
        require(['../pages/questionsOrAnswers/conversation.vue'], resolve)
      },
      meta: {
        title: '会话'
      }
    },
    {
      name: 'dispatching',
      path: '/repair/questionsOrAnswers/dispatching', // 问答v1.3
      component(resolve) {
        require(['../pages/questionsOrAnswers/dispatching.vue'], resolve)
      },
      meta: {
        title: '派单中'
      }
    },
    {
      name: 'allProblems',
      path: '/repair/questionsOrAnswers/allProblems', // 问答v1.3
      component(resolve) {
        require(['../pages/questionsOrAnswers/allProblems.vue'], resolve)
      },
      meta: {
        title: '全部问题'
      }
    },
    {
      name: 'QAndASettings',
      path: '/repair/questionsOrAnswers/QAndASettings', // 问答v1.3
      component(resolve) {
        require(['../pages/questionsOrAnswers/QAndASettings.vue'], resolve)
      },
      meta: {
        title: '接单设置'
      }
    },
    {
      name: 'problemSquare',
      path: '/repair/questionsOrAnswers/problemSquare', // 问答v1.3
      component(resolve) {
        require(['../pages/questionsOrAnswers/problemSquare.vue'], resolve)
      },
      meta: {
        title: '问题广场',
        keepAlive: true
      }
    },
    {
      name: 'adoption',
      path: '/repair/questionsOrAnswers/adoption', // 问答v1.3
      component(resolve) {
        require(['../pages/questionsOrAnswers/adoption.vue'], resolve)
      },
      meta: {
        title: '去采纳'
      }
    },
    {
      name: 'putQuestion',
      path: '/repair/shopping/putQuestion', // 问答v1.3
      component(resolve) {
        require(['../pages/questionsOrAnswers/putQuestion.vue'], resolve)
      },
      meta: {
        title: '立即提问'
      }
    },
    // {
    //   name: 'questionsOrAnswers',
    //   path: '/repair/questionsOrAnswers', // 问答v1.3
    //   component(resolve) {
    //     require(['../pages/questionsOrAnswers/index.vue'], resolve)
    //   },
    //   meta: {
    //     title: '极速问答'
    //   }
    // },
    {
      name: 'redEnvelopeRecord',
      path: '/repair/questionsOrAnswers/redEnvelopeRecord', // 问答v1.5
      component(resolve) {
        require(['../pages/questionsOrAnswers/redEnvelopeRecord.vue'], resolve)
      },
      meta: {
        title: '问答红包'
      }
    },
    {
      name: 'customIntimacy', // 客户亲密度
      path: '/repair/customIntimacy',
      component(resolve) {
        require(['../pages/singlePage/customIntimacy/customIntimacy.vue'], resolve)
      },
      meta: {
        title: '亲密度'
      }
    },
    {
      name: 'myIntimacyCustomer', // 我的亲密客户
      path: '/repair/myIntimacyCustomer',
      component(resolve) {
        require(['../pages/singlePage/customIntimacy/myIntimacyCustomer.vue'], resolve)
      },
      meta: {
        title: '我的亲密客户'
      }
    },
    {
      name: 'waitAuditList', // 待审核亲密用户
      path: '/repair/intimacy/waitAuditList',
      component(resolve) {
        require(['../pages/singlePage/customIntimacy/waitAuditList.vue'], resolve)
      },
      meta: {
        title: '待审核'
      }
    },
    {
      name: 'dataAnalysis', // 万物皆可埋点
      path: '/repair/dataanalysis',
      component(resolve) {
        require(['../pages/singlePage/record_point/record_point.vue'], resolve)
      },
      meta: {
        title: '卡修宝典'
      }
    },
    {
      name: 'libIndex', // 数据图书馆-电路图
      path: '/repair/library/index',
      component(resolve) {
        require(['../pages/dataLibrary/index.vue'], resolve)
      },
      meta: {
        title: '产品库索引'
      }
    },
    {
      name: 'circuitDiagram', // 数据图书馆-电路图
      path: '/repair/library/circuitDiagram',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram/circuitDiagram.vue'], resolve)
      },
      meta: {
        title: '电路图'
      }
    },
    {
      name: 'carModule', // 数据图书馆-电路图-车身模块 ***
      path: '/repair/library/circuitDiagram/carModule/:filterCode/:parentId',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram/CSMK_CIRCUIT_IMG/index.vue'], resolve)
      },
      meta: {
        title: '车身模块电路图'
      }
    },
    {
      name: 'ABS', // 数据图书馆-电路图-ABS ***
      path: '/repair/library/circuitDiagram/ABS/:filterCode/:attributeType/:parentId',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram/ABS_CIRCUIT_IMG/index.vue'], resolve)
      },
      meta: {
        title: 'ABS 电路图'
      }
    },
    {
      name: 'absFilterResult', // 数据图书馆-电路图-ABS-ABS品牌 ***
      path: '/repair/library/circuitDiagram/absFilterResult/:filterCode/:attributeType/:directoryId/:parentId',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram/ABS_CIRCUIT_IMG/absFilterResult.vue'], resolve)
      },
      meta: {
        title: 'ABS 电路图'
      }
    },
    {
      name: 'carBrandFilterIndex', // 数据图书馆-电路图-ABS-车辆品牌1 ***
      path: '/repair/library/circuitDiagram/carBrandFilterIndex/:filterCode/:attributeType/:parentId',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram/ABS_CIRCUIT_IMG/carBrandFilterIndex.vue'], resolve)
      },
      meta: {
        title: 'ABS 电路图'
      }
    },
    {
      name: 'carBrandFilterResult', // 数据图书馆-电路图-ABS-车辆品牌2 ***
      path: '/repair/library/circuitDiagram/carBrandFilterResult/:filterCode/:usId/:parentId/:attributeType',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram/ABS_CIRCUIT_IMG/carBrandFilterResult.vue'], resolve)
      },
      meta: {
        title: 'ABS 电路图'
      }
    },
    {
      name: 'senActFilterIndex', // 数据图书馆-电路图-传感器/执行器针脚定义1 ***
      path: '/repair/library/circuitDiagram/senActFilterIndex/:filterCode/:directoryId/:attributeType',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram/SEN_ACT_CIRCUIT_IMG/index.vue'], resolve)
      },
      meta: {
        title: '传感器/执行器针脚定义'
      }
    },
    {
      name: 'senActFilterResult', // 数据图书馆-电路图-传感器/执行器针脚定义2 ***
      path: '/repair/library/circuitDiagram/senActFilterResult/:filterCode/:directoryId/:usId',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram/SEN_ACT_CIRCUIT_IMG/result.vue'], resolve)
      },
      meta: {
        title: '传感器/执行器针脚定义'
      }
    },
    {
      name: 'hclCircuitImg', // 数据图书馆-电路图-后处理尿素泵
      path: '/repair/library/circuitDiagram/hclCircuitImg/:filterCode/:directoryId/:attributeType',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram/HCL_CIRCUIT_IMG/index.vue'], resolve)
      },
      meta: {
        title: '后处理/尿素泵电路图'
      }
    },
    {
      name: 'filter', // 数据图书馆-电路图筛选页
      path: '/repair/library/circuitDiagram/filter/:filterCode/:attributeType/:directoryId',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram/commonECU/search.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'aftertreatment', // 数据图书馆-后处理
      path: '/repair/library/aftertreatmentLibrary',
      component(resolve) {
        require(['../pages/dataLibrary/afterTreatment/aftertreatment.vue'], resolve)
      },
      meta: {
        title: '后处理'
      }
    },
    {
      name: 'folderView', // 数据图书馆-后处理-DPF/EGR
      path: '/repair/library/folderView',
      component(resolve) {
        require(['../pages/dataLibrary/afterTreatment/list.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'entireCarData', // 数据图书馆-整车资料
      path: '/repair/library/entireCarData',
      component(resolve) {
        require(['../pages/dataLibrary/entireCarData/entireCarData.vue'], resolve)
      },
      meta: {
        title: '整车资料'
      }
    },
    {
      name: 'engineData', // 数据图书馆-发动机资料 ***
      path: '/repair/library/engineData',
      component(resolve) {
        require(['../pages/dataLibrary/engineData/engineData.vue'], resolve)
      },
      meta: {
        title: '发动机资料'
      }
    },
    {
      name: 'dataStream', // 数据图书馆-数据流
      path: '/repair/library/dataStream',
      component(resolve) {
        require(['../pages/dataLibrary/dataStream/dataStream.vue'], resolve)
      },
      meta: {
        title: '数据流'
      }
    },
    {
      name: 'faultCase', // 数据图书馆-故障案例
      path: '/repair/library/faultCase',
      component(resolve) {
        require(['../pages/dataLibrary/faultCase/faultCase.vue'], resolve)
      },
      meta: {
        title: '故障案例'
      }
    },
    {
      name: 'sensorActuator', // 数据图书馆-传感器/执行器1 ***
      path: '/repair/library/sensorActuator',
      component(resolve) {
        require(['../pages/dataLibrary/sensorActuator/sensorActuator.vue'], resolve)
      },
      meta: {
        title: '传感器/执行器'
      }
    },
    {
      name: 'sensorActuatorResult', // 数据图书馆-传感器/执行器2 ***
      path: '/repair/library/sensorActuatorResult/:directoryId/:usId',
      component(resolve) {
        require(['../pages/dataLibrary/sensorActuator/sensorActuatorResult.vue'], resolve)
      },
      meta: {
        title: '传感器/执行器'
      }
    },
    {
      name: 'engineerMachinery', // 数据图书馆-工程机械
      path: '/repair/library/engineerMachinery',
      component(resolve) {
        require(['../pages/dataLibrary/engineerMachinery/engineerMachinery.vue'], resolve)
      },
      meta: {
        title: '工程机械'
      }
    },
    {
      name: 'singlePageResult', // 数据图书馆-工程机械、后处理通用结果页
      path: '/repair/library/singlePageResult',
      component(resolve) {
        require(['../pages/dataLibrary/components/singlePageResult.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'filterResult', // 数据图书馆-公用筛选结果页
      path: '/repair/library/filterResult/:filterCode/:directoryId/:firstUSId',
      component(resolve) {
        require(['../pages/dataLibrary/components/searchResult.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'queryFaultCode', // 数据图书馆-故障码查询
      path: '/repair/library/queryFaultCode',
      component(resolve) {
        require(['../pages/dataLibrary/faultCode/index.vue'], resolve)
      },
      meta: {
        title: '故障码查询'
      }
    },
    {
      name: 'oilPump', // 数据图书馆-油泵油嘴
      path: '/repair/library/oilPump',
      component(resolve) {
        require(['../pages/dataLibrary/oilPump/index.vue'], resolve)
      },
      meta: {
        title: '油泵油嘴'
      }
    },
    {
      name: 'partInfo', // 数据图书馆_部件信息
      path: '/repair/library/partInfo',
      component(resolve) {
        require(['../pages/dataLibrary/partInfo/index.vue'], resolve)
      },
      meta: {
        title: '部件信息'
      }
    },
    {
      name: 'drawPrice', // 活动-快乐大抽奖
      path: '/repair/singlepage/drawprice',
      component(resolve) {
        require(['../pages/singlePage/activity_drawPrice/drawPrice.vue'], resolve)
      },
      meta: {
        title: '卡修宝典'
      }
    },
    {
      name: 'priceList', // 活动-快乐大抽奖-奖品列表页
      path: '/repair/singlepage/drawprice/pricelist',
      component(resolve) {
        require(['../pages/singlePage/activity_drawPrice/priceList.vue'], resolve)
      },
      meta: {
        title: '卡修宝典'
      }
    },
    {
      name: 'invitee', // 活动页面-受邀人
      path: '/repair/shopping/invitee',
      component(resolve) {
        require(['../pages/activityPage/invitee.vue'], resolve)
      },
      meta: {
        title: '卡修宝典'
      }
    },
    {
      name: 'participant', // 活动页面-参与人
      path: '/repair/shopping/participant',
      component(resolve) {
        require(['../pages/activityPage/participant.vue'], resolve)
      },
      meta: {
        title: '卡修宝典'
      }
    },
    {
      name: 'invitation', // 邀请有礼
      path: '/repair/member/invitation',
      component(resolve) {
        require(['../pages/memberCenter/personal/invitation/invitation.vue'], resolve)
      },
      meta: {
        title: '邀请有礼'
      }
    },
    {
      name: 'repairQuestionnaire', // 维修案例编辑器
      path: '/repair/repairQuestionnaire',
      component(resolve) {
        require(['../pages/questionnaire/repairQuestionnaire.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'customEquipConsult', // 用户端-设备购买咨询
      path: '/repair/equip/customEquipConsult',
      component(resolve) {
        require(['../pages/equipConsult/customer/consult.vue'], resolve)
      },
      meta: {
        title: '设备购买咨询'
      }
    },
    {
      name: 'equipHistoryList', // 设备购买咨询-历史记录-列表页
      path: '/repair/equip/historyList',
      component(resolve) {
        require(['../pages/equipConsult/history/historyList.vue'], resolve)
      },
      meta: {
        title: '设备购买咨询'
      }
    },
    {
      path: '/repair/equip/staff', // 员工端-设备购买咨询
      component(resolve) {
        require(['../pages/equipConsult/consultIndex.vue'], resolve)
      },
      children: [{
        name: 'equipHistoryDetail', // 员工端-设备购买咨询-历史记录-详情页
        path: 'historyDetail',
        component(resolve) {
          require(['../pages/equipConsult/history/historyDetail.vue'], resolve)
        },
        meta: {
          title: '设备购买咨询-后台'
        }
      },
      {
        name: 'equipConsultList', // 员工端-设备购买咨询-咨询列表
        path: 'list',
        component(resolve) {
          require(['../pages/equipConsult/staff/consultList.vue'], resolve)
        },
        meta: {
          title: '设备购买咨询-后台'
        }
      },
      {
        name: 'equipConsultDetail', // 员工端-设备购买咨询-咨询详情页
        path: 'detail',
        component(resolve) {
          require(['../pages/equipConsult/staff/consultDetail.vue'], resolve)
        },
        meta: {
          title: '设备购买咨询-后台'
        }
      }
      ],
      meta: {
        title: '设备购买咨询-后台'
      }
    },
    {
      name: 'posterLandingPage', // 分享海报落地页
      path: '/repair/posterPage/index',
      component(resolve) {
        require(['../pages/singlePage/posterPage.vue'], resolve)
      },
      meta: {
        title: '卡修宝典'
      }
    },
    {
      name: 'answerAndAward', // 答题得现金
      path: '/repair/answerAndAward/index',
      component(resolve) {
        require(['../pages/answerAndAward/answerAndAward.vue'], resolve)
      },
      meta: {
        title: '答题得现金'
      }
    },
    {
      name: 'rankList', // 社区内容-排行榜
      path: '/repair/community/rankList',
      component(resolve) {
        require(['../pages/community/rankList/rankList.vue'], resolve)
      },
      meta: {
        title: '排行榜'
      }
    },
    {
      name: 'dailyCheck', // 社区内容-任务中心-每日签到
      path: '/repair/community/dailyCheck',
      component(resolve) {
        require(['../pages/community/taskCenter/dailyCheck.vue'], resolve)
      },
      meta: {
        title: '每日签到'
      }
    },
    {
      name: 'starsDetail', // 社区内容-任务中心-星豆明细
      path: '/repair/community/starsDetail',
      component(resolve) {
        require(['../pages/community/taskCenter/starsDetail.vue'], resolve)
      },
      meta: {
        title: '我的星豆'
      }
    },
    {
      name: 'myStars', // 社区内容-任务中心-我的星豆
      path: '/repair/community/myStars',
      component(resolve) {
        require(['../pages/community/taskCenter/myStars.vue'], resolve)
      },
      meta: {
        title: '星豆兑换'
      }
    },
    {
      name: 'signIn', // 社区内容-任务中心-签到表
      path: '/repair/community/signIn',
      component(resolve) {
        require(['../pages/community/taskCenter/signIn.vue'], resolve)
      },
      meta: {
        title: '我的签到表'
      }
    },
    {
      name: 'taskCenter', // 社区内容-任务中心
      path: '/repair/community/taskCenter',
      component(resolve) {
        require(['../pages/community/taskCenter/taskCenter.vue'], resolve)
      },
      meta: {
        title: '任务中心'
      }
    },
    {
      name: 'sharePoster', // 任务中心-分享海报
      path: '/repair/community/sharePoster',
      component(resolve) {
        require(['../pages/community/taskCenter/sharePoster.vue'], resolve)
      },
      meta: {
        title: '分享海报到朋友圈'
      }
    },
    {
      name: 'carCodeTask', // 车辆部件信息任务
      path: '/repair/community/carCodeTask',
      component(resolve) {
        require(['../pages/community/taskCenter/carCodeTask.vue'], resolve)
      },
      meta: {
        title: '车辆部件信息任务'
      }
    },
    {
      name: 'meansCollect', // 资料经验收集
      path: '/repair/community/meansCollect',
      component(resolve) {
        require(['../pages/community/taskCenter/meansCollect.vue'], resolve)
      },
      meta: {
        title: '卡修宝典'
      }
    },
    {
      name: 'receiveRedPacket', // 参与活动领红包
      path: '/repair/community/receiveRedPacket',
      component(resolve) {
        require(['../pages/community/taskCenter/receiveRedPacket.vue'], resolve)
      },
      meta: {
        title: '参与活动领红包'
      }
    },
    {
      name: 'workbenchArticle', // 社区内容-内部工作台-列表页
      path: '/repair/community/workbenchArticle',
      component(resolve) {
        require(['../pages/community/workbench/workbench.vue'], resolve)
      },
      meta: {
        title: '内部工作台'
      }
    },
    {
      name: 'workbenchComment', // 社区内容-内部工作台-列表页
      path: '/repair/community/workbenchComment',
      component(resolve) {
        require(['../pages/community/workbench/workbench.vue'], resolve)
      },
      meta: {
        title: '内部工作台'
      }
    },
    // {
    //   name: 'community', // 社区-首页
    //   path: '/repair/community/index',
    //   component(resolve) {
    //     require(['../pages/community/community.vue'], resolve)
    //   },
    //   meta: {
    //     title: '交流社区'
    //   }
    // },
    {
      name: 'communityNotice', // 社区-公告栏
      path: '/repair/community/notice',
      component(resolve) {
        require(['../pages/community/notice.vue'], resolve)
      },
      meta: {
        title: '社区公告栏'
      }
    },
    {
      name: 'communitySearch', // 社区-搜索
      path: '/repair/community/search',
      component(resolve) {
        require(['../pages/community/search.vue'], resolve)
      },
      meta: {
        title: '社区搜索'
      }
    },
    // {
    //   name: 'communityWxpost', // 社区-发图文
    //   path: '/repair/community/wxpost',
    //   component(resolve) {
    //     require(['../pages/community/wxpost.vue'], resolve)
    //   },
    //   meta: {
    //     title: '发帖'
    //   }
    // },
    // {
    //   name: 'commentMessage', // 社区-社区消息通知-评论
    //   path: '/repair/community/commentMessage',
    //   component(resolve) {
    //     require(['../pages/community/message/commentMessage.vue'], resolve)
    //   },
    //   meta: {
    //     title: '社区消息通知'
    //   }
    // },
    // {
    //   name: 'likeMessage', // 社区-社区消息通知-点赞
    //   path: '/repair/community/likeMessage',
    //   component(resolve) {
    //     require(['../pages/community/message/likeMessage.vue'], resolve)
    //   },
    //   meta: {
    //     title: '社区消息通知'
    //   }
    // },
    {
      name: 'communityPersonalInfo', // 社区-个人资料
      path: '/repair/person/personalInfo',
      component(resolve) {
        require(['../pages/community/personalPage/personalInfo.vue'], resolve)
      },
      meta: {
        title: '个人资料'
      }
    },
    // {
    //   name: 'following', // 社区-我\他关注的人
    //   path: '/repair/community/following',
    //   component(resolve) {
    //     require(['../pages/community/personalPage/follow/following.vue'], resolve)
    //   },
    //   meta: {
    //     title: ''
    //   }
    // },
    // {
    //   name: 'followers', // 社区-关注我\他的人
    //   path: '/repair/community/followers',
    //   component(resolve) {
    //     require(['../pages/community/personalPage/follow/followers.vue'], resolve)
    //   },
    //   meta: {
    //     title: ''
    //   }
    // },
    // {
    //   name: 'myPage', // 社区-我的主页
    //   path: '/repair/community/myPage',
    //   component(resolve) {
    //     require(['../pages/community/personalPage/myPage.vue'], resolve)
    //   },
    //   meta: {
    //     title: '我的主页'
    //   }
    // },
    // {
    //   name: 'otherPage', // 社区-别人的主页
    //   path: '/repair/community/otherPage',
    //   component(resolve) {
    //     require(['../pages/community/personalPage/otherPage.vue'], resolve)
    //   },
    //   meta: {
    //     title: '他的主页'
    //   }
    // },
    {
      name: 'articleDetail', // 社区-帖子详情
      path: '/repair/community/articleDetail',
      component(resolve) {
        require(['../pages/community/articleDetail.vue'], resolve)
      },
      meta: {
        title: '帖子详情'
      }
    },
    {
      name: 'newArticleDetail', // 社区-帖子详情
      path: '/repair/community/newArticleDetail',
      component(resolve) {
        require(['../pages/community/newArticleDetail.vue'], resolve)
      },
      meta: {
        title: '帖子详情'
      }
    },
    // {
    //   name: 'articleReward', // 社区-帖子详情-打赏
    //   path: '/repair/shopping/articleReward',
    //   component(resolve) {
    //     require(['../pages/community/components/reward.vue'], resolve)
    //   },
    //   meta: {
    //     title: '打赏'
    //   }
    // },
    // {
    //   name: 'modulPageList', // 社区-模块-列表页
    //   path: '/repair/community/modulPageList',
    //   component(resolve) {
    //     require(['../pages/community/plate/modulPageList.vue'], resolve)
    //   },
    //   meta: {
    //     title: '话题版块'
    //   }
    // },
    // {
    //   name: 'modulPage', // 社区-模块页
    //   path: '/repair/community/modulPage',
    //   component(resolve) {
    //     require(['../pages/community/plate/modulPage.vue'], resolve)
    //   },
    //   meta: {
    //     title: '话题版块'
    //   }
    // },
    // {
    //   name: 'askAnswerIndex', // 社区-修车问答
    //   path: '/repair/community/askAnswerIndex',
    //   component(resolve) {
    //     require(['../pages/community/askAndAnswer/index.vue'], resolve)
    //   },
    //   meta: {
    //     title: '修车问答'
    //   }
    // },
    // {
    //   name: 'askAnswerputQue', // 社区-修车问答_我要提问
    //   path: '/repair/community/askAnswerPutQue',
    //   component(resolve) {
    //     require(['../pages/community/askAndAnswer/putQuestion.vue'], resolve)
    //   },
    //   meta: {
    //     title: '我要提问题'
    //   }
    // },
    // {
    //   name: 'askDetailAndAnswerList', // 社区-修车问答_问答详情和回答列表
    //   path: '/repair/community/askDetailAndAnswerList',
    //   component(resolve) {
    //     require(['../pages/community/askAndAnswer/askDetailAndAnswerList.vue'], resolve)
    //   },
    //   meta: {
    //     title: '修车问答'
    //   }
    // },
    // {
    //   name: 'answerDetail', // 社区-修车问答_回答详情
    //   path: '/repair/community/answerDetail',
    //   component(resolve) {
    //     require(['../pages/community/askAndAnswer/answerDetail.vue'], resolve)
    //   },
    //   meta: {
    //     title: '修车问答'
    //   }
    // },
    // {
    //   name: 'examine', // 社区-修车问答_系统用户审核
    //   path: '/repair/community/examine',
    //   component(resolve) {
    //     require(['../pages/community/askAndAnswer/examine.vue'], resolve)
    //   },
    //   meta: {
    //     title: '修车问答'
    //   }
    // },
    {
      name: 'classCourseList', // 在线课堂-班课列表页
      path: '/repair/shopping/classCourseList',
      component(resolve) {
        require(['../pages/onlineCourse/classCourse/classCourseList.vue'], resolve)
      },
      meta: {
        title: '卡修宝典班课'
      }
    },
    {
      name: 'classCourseIntro', // 在线课堂-班课介绍页
      path: '/repair/shopping/courseIntro',
      component(resolve) {
        require(['../pages/onlineCourse/classCourse/classCourseIntro.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'classCourse', // 在线课堂-班课
      path: '/repair/shopping/classCourse',
      component(resolve) {
        require(['../pages/onlineCourse/classCourse/classCourse.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'classCoursePlayer', // 在线课堂-班课-视频播放页
      path: '/repair/shopping/classCoursePlayer',
      component(resolve) {
        require(['../pages/onlineCourse/classCourse/classCourseVideo.vue'], resolve)
      },
      meta: {
        title: '课程详情'
      }
    },
    {
      name: 'onlineCourseList', // 在线课堂-课程列表页
      path: '/repair/shopping/onlineCourseList',
      component(resolve) {
        require(['../pages/onlineCourse/index.vue'], resolve)
      },
      meta: {
        title: '学技术'
      }
    },
    {
      name: 'onlineCoursePlate', // 在线课堂-课程板块详情页
      path: '/repair/courseListPlate',
      component(resolve) {
        require(['../pages/onlineCourse/plate/plateDetail.vue'], resolve)
      },
      meta: {
        title: '课程'
      }
    },
    {
      name: 'courseSearch', // 在线课堂-搜索结果页
      path: '/repair/onlineCourse/courseSearch',
      component(resolve) {
        require(['../pages/onlineCourse/courseSearch.vue'], resolve)
      },
      meta: {
        title: '搜索结果'
      }
    },
    {
      name: 'studyRecord', // 在线课堂-学习记录
      path: '/repair/onlineCourse/studyRecord',
      component(resolve) {
        require(['../pages/onlineCourse/studyRecord.vue'], resolve)
      },
      meta: {
        title: '学习记录'
      }
    },
    {
      name: 'unlimitCard', // 在线课堂-课程列表页-课堂畅享卡
      path: '/repair/shopping/unlimitCard',
      component(resolve) {
        require(['../pages/onlineCourse/unlimitCard.vue'], resolve)
      },
      meta: {
        title: '课堂畅享卡'
      }
    },
    {
      name: 'livePlayback', // 在线课堂-直播回放页
      path: '/repair/shopping/livePlayback',
      component(resolve) {
        require(['../pages/onlineCourse/live/livePlayback.vue'], resolve)
      },
      meta: {
        title: '直播回放'
      }
    },
    {
      name: 'shareTicket', // 在线课堂-分享领取听课券
      path: '/repair/shopping/shareTicket',
      component(resolve) {
        require(['../pages/onlineCourse/live/shareTicket.vue'], resolve)
      },
      meta: {
        title: '犇犇课堂'
      }
    },
    {
      name: 'courseLive', // 在线课堂-犇犇课堂直播
      path: '/repair/shopping/courseLive',
      component(resolve) {
        require(['../pages/onlineCourse/live/courseLive.vue'], resolve)
      },
      meta: {
        title: '犇犇课堂'
      }
    },
    {
      name: 'courseLiveNew', // 在线课堂-犇犇课堂直播
      path: '/repair/shopping/courseLiveNew',
      component(resolve) {
        require(['../pages/onlineCourse/live/courseLiveNew.vue'], resolve)
      },
      meta: {
        title: '犇犇课堂'
      }
    },
    {
      name: 'liveCurricu', // 卡修宝典直播首页
      path: '/repair/liveCurricu',
      component(resolve) {
        require(['../pages/onlineCourse/live/curricuIndex.vue'], resolve)
      },
      meta: {
        title: '直播'
      }
    },
    {
      name: 'liveCurricuDetail', // 卡修宝典直播详情页
      path: '/repair/liveCurricuDetail',
      component(resolve) {
        require(['../pages/onlineCourse/live/curricuDetail.vue'], resolve)
      },
      meta: {
        title: '直播'
      }
    },
    {
      name: 'playbackPlayer', // 在线课堂-犇犇课堂直播回放单页
      path: '/repair/shopping/playbackPlayer',
      component(resolve) {
        require(['../pages/onlineCourse/live/playbackPlayer.vue'], resolve)
      },
      meta: {
        title: '犇犇课堂'
      }
    },
    {
      name: 'ownedCourse', // 在线课堂-已购课程
      path: '/repair/shopping/ownedCourse',
      component(resolve) {
        require(['../pages/onlineCourse/course/ownedCourseList.vue'], resolve)
      },
      meta: {
        title: '学习记录'
      }
    },
    {
      name: 'onlineCourseDetail', // 在线课堂-课程详情页
      path: '/repair/shopping/courseDetail',
      component(resolve) {
        require(['../pages/onlineCourse/course/newCourseDetail.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'customerManage', // 客户管理工具
      path: '/repair/customer/customerManage',
      component(resolve) {
        require(['../pages/customer/customerManage/customerManage.vue'], resolve)
      },
      meta: {
        title: '客户管理工具'
      }
    },
    {
      name: 'fansList', // 客户管理工具——服务站粉丝客户
      path: '/repair/customer/fansList',
      component(resolve) {
        require(['../pages/customer/customerManage/myFansList.vue'], resolve)
      },
      meta: {
        title: '我的粉丝'
      }
    },
    {
      name: 'operationList', // 小轨讲运营列表页
      path: '/repair/customer/operationList',
      component(resolve) {
        require(['../pages/customer/customerManage/operationTeach/operationList.vue'], resolve)
      },
      meta: {
        title: '小轨讲运营'
      }
    },
    {
      name: 'acticleDetail', // 小轨讲运营文章详情页
      path: '/repair/customer/acticleDetail',
      component(resolve) {
        require(['../pages/customer/customerManage/operationTeach/articleDetail.vue'], resolve)
      },
      meta: {
        title: '文章详情'
      }
    },
    {
      name: 'businessCard', // 店铺名片页面
      path: '/repair/customer/customerManage/businessCard',
      component(resolve) {
        require(['../pages/customer/customerManage/businessCard/businessCard.vue'], resolve)
      },
      meta: {
        title: '店铺名片'
      }
    },
    {
      name: 'mainBusiness', // 主营业务编辑页面
      path: '/repair/customer/customerManage/businessCard/mainBusiness',
      component(resolve) {
        require(['../pages/customer/customerManage/businessCard/mainBusiness.vue'], resolve)
      },
      meta: {
        title: '主营业务'
      }
    },
    {
      name: 'shopImg', // 店铺风采页面
      path: '/repair/customer/customerManage/businessCard/shopImg',
      component(resolve) {
        require(['../pages/customer/customerManage/businessCard/shopImg.vue'], resolve)
      },
      meta: {
        title: '店铺风采'
      }
    },
    {
      name: 'shopHead', // 店铺头像上传页面
      path: '/repair/customer/customerManage/businessCard/shopHead',
      component(resolve) {
        require(['../pages/customer/customerManage/businessCard/shopHead.vue'], resolve)
      },
      meta: {
        title: '店铺头像'
      }
    },
    {
      name: 'arrivalActivity', // 客户管理工具到店活动
      path: '/repair/customer/customerManage/arrivalActivity',
      component(resolve) {
        require(['../pages/customer/customerManage/arrivalActivity/arrivalActivity.vue'], resolve)
      },
      meta: {
        title: '到店活动'
      }
    },
    {
      name: 'newActivity', // 客户管理工具——新增到店活动
      path: '/repair/customer/customerManage/newActivity',
      component(resolve) {
        require(['../pages/customer/customerManage/arrivalActivity/newActivity.vue'], resolve)
      },
      meta: {
        title: '新增到店活动'
      }
    },
    {
      name: 'activityUnderway', // 客户管理工具——到店活动进行中
      path: '/repair/customer/customerManage/activityUnderway',
      component(resolve) {
        require(['../pages/customer/customerManage/arrivalActivity/activityUnderway.vue'], resolve)
      },
      meta: {
        title: '到店活动'
      }
    },
    {
      name: 'activityEnd', // 客户管理工具——到店活动结束
      path: '/repair/customer/customerManage/activityEnd',
      component(resolve) {
        require(['../pages/customer/customerManage/arrivalActivity/activityEnd.vue'], resolve)
      },
      meta: {
        title: '活动结束'
      }
    },
    {
      name: 'activityDel', // 客户管理工具——到店活动删除
      path: '/repair/customer/customerManage/activityDel',
      component(resolve) {
        require(['../pages/customer/customerManage/arrivalActivity/activityDel.vue'], resolve)
      },
      meta: {
        title: '活动删除'
      }
    },
    {
      name: 'marketing', // 营销活动管理页面
      path: '/repair/customer/customerManage/marketing',
      component(resolve) {
        require(['../pages/customer/customerManage/marketing/marketing.vue'], resolve)
      },
      meta: {
        title: '营销管理'
      }
    },
    {
      name: 'newDraw', // 营销活动-新建抽奖活动
      path: '/repair/customer/customerManage/newDraw',
      component(resolve) {
        require(['../pages/customer/customerManage/marketing/newDraw.vue'], resolve)
      },
      meta: {
        title: '新增抽奖活动'
      }
    },
    {
      name: 'marketingDetailNoStart', // 营销活动-抽奖详情-未开始
      path: '/repair/customer/customerManage/marketingDetailNoStart',
      component(resolve) {
        require(['../pages/customer/customerManage/marketing/marketingDetailNoStart.vue'], resolve)
      },
      meta: {
        title: '抽奖活动详情'
      }
    },
    {
      name: 'marketingDetailGoing', // 营销活动-抽奖详情-进行中
      path: '/repair/customer/customerManage/marketingDetailGoing',
      component(resolve) {
        require(['../pages/customer/customerManage/marketing/marketingDetailGoing.vue'], resolve)
      },
      meta: {
        title: '抽奖活动详情'
      }
    },
    {
      name: 'marketingDetailEnd', // 营销活动-抽奖详情-已结束
      path: '/repair/customer/customerManage/marketingDetailEnd',
      component(resolve) {
        require(['../pages/customer/customerManage/marketing/marketingDetailEnd.vue'], resolve)
      },
      meta: {
        title: '抽奖活动详情'
      }
    },
    {
      name: 'customerDetail', // 客户资料
      path: '/repair/customer/customerDetail',
      component(resolve) {
        require(['../pages/customer/customerManage/customerDetail/customerDetail.vue'], resolve)
      },
      meta: {
        title: '客户资料'
      }
    },
    {
      name: 'customerRecommend', // 客户推荐列表
      path: '/repair/customer/customerRecommend',
      component(resolve) {
        require(['../pages/customer/customerManage/customerDetail/customerRecommend.vue'], resolve)
      },
      meta: {
        title: '客户推荐记录'
      }
    },
    {
      name: 'customerEdit', // 客户资料编辑
      path: '/repair/customer/customerEdit',
      component(resolve) {
        require(['../pages/customer/customerManage/customerEdit/customerEdit.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'dynamic', // 客户管理工具——发动态页面
      path: '/repair/customer/dynamic',
      component(resolve) {
        require(['../pages/customer/customerManage/dynamic.vue'], resolve)
      },
      meta: {
        title: '发动态'
      }
    },
    {
      name: 'bookkeeping', // 客户管理工具——记账统计
      path: '/repair/customer/bookkeeping',
      component(resolve) {
        require(['../pages/customer/customerManage/bookkeeping.vue'], resolve)
      },
      meta: {
        title: '记账统计'
      }
    },
    {
      name: 'followMe',
      path: '/repair/common/followMe',
      component(resolve) {
        require(['../pages/common/followMe.vue'], resolve)
      },
      meta: {
        title: '关注卡修宝典'
      }
    },
    {
      name: 'remoteSupport',
      path: '/repair/DiagnosticSpecialist/remoteSupport',
      component(resolve) {
        require(['../pages/system/DiagnosticSpecialist/remoteSupport.vue'], resolve)
      },
      meta: {
        title: '诊断能手远程支持'
      }
    }, {
      name: 'certification',
      path: '/repair/auth/certification',
      component(resolve) {
        require(['../pages/common/certification.vue'], resolve)
      },
      meta: {
        title: '活动报名联系方式'
      }
    }, {
      name: 'certificationRenewal',
      path: '/repair/business/pay/certificationRenewal',
      component(resolve) {
        require(['../pages/common/memberCenter.vue'], resolve)
      },
      meta: {
        title: '会员中心'
      }
    }, {
      name: 'giftTickets',
      path: '/repair/member/center/giftTickets',
      component(resolve) {
        require(['../pages/common/giftTickets.vue'], resolve)
      },
      meta: {
        title: '获劵记录'
      }
    },
    {
      name: 'testDataQuery',
      path: '/repair/soso/testDataQuery',
      component(resolve) {
        require(['../pages/soso/testData/testDataQuery.vue'], resolve)
      },
      meta: {
        title: '测试数据查询'
      }
    },

    {
      name: 'openMember',
      path: '/repair/business/pay/openMember',
      component(resolve) {
        require(['../pages/common/certificationRenewal.vue'], resolve)
      },
      meta: {
        title: '开通会员'
      }
    },
    {
      name: 'questionDealed',
      path: '/repair/shopping/questionDealed',
      component(resolve) {
        require(['../pages/shopping/questionDealed.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'noDealed',
      path: '/repair/shopping/noDealed',
      component(resolve) {
        require(['../pages/shopping/noDealed.vue'], resolve)
      },
      meta: {
        title: '在线问答'
      }
    },
    {
      name: 'vipPhoneService',
      path: '/repair/shopping/vipPhoneService',
      component(resolve) {
        require(['../pages/shopping/vipPhoneService.vue'], resolve)
      },
      meta: {
        title: '在线问答'
      }
    },
    {
      path: '/repair/faultCode/index',
      component(resolve) {
        require(['../pages/soso/faultCode/index.vue'], resolve)
      },
      meta: {
        title: '故障代码查询'
      }
    },
    {
      name: 'faultList',
      path: '/repair/faultCode/list',
      component(resolve) {
        require(['../pages/soso/faultCode/list.vue'], resolve)
      },
      meta: {
        title: '故障代码查询'
      }
    },
    {
      name: 'advancedSearch',
      path: '/repair/faultCode/advancedSearch',
      component(resolve) {
        require(['../pages/soso/faultCode/advancedSearch.vue'], resolve)
      },
      meta: {
        title: '故障代码高级查询'
      }
    },
    {
      name: 'partsInfoIndex',
      path: '/repair/partsInfo/index',
      component(resolve) {
        require(['../pages/soso/partsInfo/index.vue'], resolve)
      },
      meta: {
        title: '配套信息'
      }
    },
    {
      path: '/repair/datum',
      component(resolve) {
        require(['../pages/soso/datum/index.vue'], resolve)
      },
      meta: {
        title: '资料大全'
      },
      children: [{
        name: 'datumSearch',
        path: 'datumSearch',
        component(resolve) {
          require(['../pages/soso/datum/datumSearch.vue'], resolve)
        },
        meta: {
          title: '资料大全'
        }
      }, {
        name: 'engine',
        path: 'engine',
        component(resolve) {
          require(['../pages/soso/datum/engine.vue'], resolve)
        },
        meta: {
          title: '发动机资料'
        }
      }, {
        name: 'datumList',
        path: 'datumList',
        component(resolve) {
          require(['../components/datum/datumList.vue'], resolve)
        },
        meta: {
          title: '资料大全'
        }
      }]
    },
    {
      path: '/repair/universalSoso/index',
      component(resolve) {
        require(['../pages/soso/universal/index.vue'], resolve)
      },
      meta: {
        title: '万能搜搜'
      }
    },
    {
      name: 'universalSerList',
      path: '/repair/universalSoso/searchList',
      component(resolve) {
        require(['../pages/soso/universal/universaSosoList.vue'], resolve)
      },
      meta: {
        title: '万能搜搜'
      }
    },
    {
      name: 'lectureRoom',
      path: '/repair/lectureRoom',
      component(resolve) {
        require(['../pages/lectureRoom/scoop/index.vue'], resolve)
      },
      meta: {
        title: '小轨特训'
      }
    }, {
      name: 'courseWare',
      path: '/repair/lectureRoom/courseWare',
      component(resolve) {
        require(['../pages/lectureRoom/scoop/courseWare.vue'], resolve)
      },
      meta: {
        title: '精品课件'
      }
    }, {
      name: 'courseWareList',
      path: '/repair/lectureRoom/courseWareList',
      component(resolve) {
        require(['../pages/lectureRoom/scoop/courseWareList.vue'], resolve)
      },
      meta: {
        title: '精品课件'
      }
    }, {
      name: 'advice',
      path: '/repair/lectureRoom/advice',
      component(resolve) {
        require(['../pages/lectureRoom/scoop/advice.vue'], resolve)
      },
      meta: {
        title: '评价建议'
      }
    },
    {
      name: 'currentPeriodList',
      path: '/repair/lectureRoom/current/list',
      component(resolve) {
        require(['../pages/lectureRoom/scoop/currentPeriodList.vue'], resolve)
      },
      meta: {
        title: '本期特训'
      }
    }, {
      name: 'currentPeriodCost',
      path: '/repair/lectureRoom/current/cost',
      component(resolve) {
        require(['../pages/lectureRoom/scoop/cost.vue'], resolve)
      },
      meta: {
        title: '报名'
      }
    }, {
      name: 'currentPeriodAttend',
      path: '/repair/lectureRoom/current/attend',
      component(resolve) {
        require(['../pages/lectureRoom/scoop/attend.vue'], resolve)
      },
      meta: {
        title: '特训签到'
      }
    }, {
      name: 'currentPeriodPay',
      path: '/repair/business/pay/cost',
      component(resolve) {
        require(['../pages/lectureRoom/scoop/order.vue'], resolve)
      },
      meta: {
        title: '报名支付'
      }
    }, {
      name: 'currentPeriodPay2',
      path: '/repair/lectureRoom/site/share',
      component(resolve) {
        require(['../pages/lectureRoom/scoop/siteShare.vue'], resolve)
      },
      meta: {
        title: '来自小轨的红包'
      }
    }, {
      name: 'memberCenter',
      path: '/repair/personal/center',
      component(resolve) {
        require(['../pages/memberCenter/personal/index.vue'], resolve)
      },
      meta: {
        title: '我的'
      }
    }, {
      name: 'setUp',
      path: '/repair/member/setUp',
      component(resolve) {
        require(['../pages/memberCenter/setUp.vue'], resolve)
      },
      meta: {
        title: '设置'
      }
    },
    {
      name: 'moreSetUp',
      path: '/repair/member/moreSetUp',
      component(resolve) {
        require(['../pages/memberCenter/moreSetUp.vue'], resolve)
      },
      meta: {
        title: '更多设置'
      }
    },
    {
      name: 'noCallSet',
      path: '/repair/member/noCallSet',
      component(resolve) {
        require(['../pages/memberCenter/noCallSet.vue'], resolve)
      },
      meta: {
        title: '免电话营销设置'
      }
    },
    {
      name: 'personalCertification',
      path: '/repair/member/personalCertification',
      component(resolve) {
        require(['../pages/memberCenter/personal/personalCertification.vue'], resolve)
      },
      meta: {
        title: '绑定手机号'
      }
    },
    {
      name: 'phoneChange',
      path: '/repair/member/phoneChange',
      component(resolve) {
        require(['../pages/memberCenter/personal/phoneChange.vue'], resolve)
      },
      meta: {
        title: '更换手机号'
      }
    },
    {
      name: 'memberPersonalInfo',
      path: '/repair/member/personal/info',
      component(resolve) {
        require(['../pages/memberCenter/personal/member/memberInfo.vue'], resolve)
      },
      meta: {
        title: '个人设置'
      }
    },
    /* 增加用户头像修改页面*/
    {
      name: 'changeUserHeader',
      path: '/repair/member/personal/changeUserHeader',
      component(resolve) {
        require(['../pages/memberCenter/personal/member/changeUserHeader.vue'], resolve)
      },
      meta: {
        title: '个人头像设置'
      }
    },
    {
      name: 'changeUserHeader-app',
      path: '/repair/member/personal/changeUserHeader-app',
      component(resolve) {
        require(['../pages/memberCenter/personal/member/changeUserHeader-app.vue'], resolve)
      },
      meta: {
        title: '个人头像设置'
      }
    },
    {
      name: 'opinionFank',
      path: '/repair/member/personal/opinionFank',
      component(resolve) {
        require(['../pages/memberCenter/personal/member/opinionFank.vue'], resolve)
      },
      meta: {
        title: '意见反馈'
      }
    },
    {
      name: 'helpAndFeedBack',
      path: '/repair/member/personal/helpAndFeedBack',
      component(resolve) {
        require(['../pages/memberCenter/personal/member/helpAndFeedBack.vue'], resolve)
      },
      meta: {
        title: '帮助与反馈'
      }
    }, {
      name: 'memberMyOrder',
      path: '/repair/business/pay/newOrderList',
      component(resolve) {
        require(['../pages/memberCenter/personal/order/newOrderList.vue'], resolve)
      },
      meta: {
        title: '我的订单'
      }
    },
    {
      name: 'newOrderDetail',
      path: '/repair/business/pay/newOrderDetail',
      component(resolve) {
        require(['../pages/memberCenter/personal/order/newOrderDetail.vue'], resolve)
      },
      meta: {
        title: '订单详情'
      }
    },
    {
      name: 'giftOrderDetail',
      path: '/repair/business/pay/giftOrderDetail',
      component(resolve) {
        require(['../pages/memberCenter/personal/order/giftOrderDetail.vue'], resolve)
      },
      meta: {
        title: '赠品订单详情'
      }
    },
    {
      name: 'orderReviewCancel',
      path: '/repair/business/pay/orderReviewCancel',
      component(resolve) {
        require(['../pages/memberCenter/personal/order/orderReviewCancel.vue'], resolve)
      },
      meta: {
        title: '待发货订单取消审核'
      }
    },
    {
      name: 'payMoney',
      path: '/repair/business/pay/payMoney',
      component(resolve) {
        require(['../pages/memberCenter/personal/member/payMoney.vue'], resolve)
      },
      meta: {
        title: '向卡修宝典付款'
      }
    },
    {
      name: 'newOrderListPhone',
      path: '/repair/business/pay/newOrderListPhone',
      component(resolve) {
        require(['../pages/memberCenter/personal/order/newOrderListPhone.vue'], resolve)
      },
      meta: {
        title: '手机订单'
      }
    },
    {
      name: 'memberAddress',
      path: '/repair/member/center/per/address',
      component(resolve) {
        require(['../pages/memberCenter/personal/address/addressManager.vue'], resolve)
      },
      meta: {
        title: '地址管理'
      }
    }, {
      name: 'memberAddressChange',
      path: '/repair/member/center/per/addressChange',
      component(resolve) {
        require(['../pages/memberCenter/personal/address/addressManagerChange.vue'], resolve)
      },
      meta: {
        title: '添加地址'
      }
    }, {
      name: 'memberMyGift',
      path: '/repair/member/center/per/myGift',
      component(resolve) {
        require(['../pages/memberCenter/personal/newGift/index.vue'], resolve)
      },
      meta: {
        title: '实物礼品'
      }
    }, {
      name: 'myLeftGift',
      path: '/repair/member/center/per/myLeftGift',
      component(resolve) {
        require(['../pages/memberCenter/personal/newGift/myTickets/myTickets.vue'], resolve)
      },
      meta: {
        title: '我的礼品券'
      }
    }, {
      name: 'ticketsGot',
      path: '/repair/member/center/per/ticketsGot',
      component(resolve) {
        require(['../pages/memberCenter/personal/newGift/ticketsGot/ticketsGot.vue'], resolve)
      },
      meta: {
        title: '已领礼品'
      }
    }, {
      name: 'giftDetail',
      path: '/repair/member/center/per/giftDetail',
      component(resolve) {
        require(['../pages/memberCenter/personal/newGift/giftDetail/giftDetail.vue'], resolve)
      },
      meta: {
        title: '礼品详情'
      }
    }, {
      name: 'ticketBasket',
      path: '/repair/shopping/ticketBasket',
      component(resolve) {
        require(['../pages/memberCenter/personal/newGift/ticketBasket/ticketBasket.vue'], resolve)
      },
      meta: {
        title: '我的礼品篮'
      }
    }, {
      name: 'locationList',
      path: '/repair/member/center/per/locationList',
      component(resolve) {
        require(['../pages/memberCenter/personal/newGift/locationManage/locationList.vue'], resolve)
      },
      meta: {
        title: '我的收货地址'
      }
    }, {
      name: 'locationEdit',
      path: '/repair/member/center/per/locationEdit',
      component(resolve) {
        require(['../pages/memberCenter/personal/newGift/locationManage/locationEdit.vue'], resolve)
      },
      meta: {
        title: '我的收货地址'
      }
    },
    {
      name: 'giftOrderAudit',
      path: '/repair/shopping/giftOrderAudit',
      component(resolve) {
        require(['../pages/memberCenter/personal/gift/giftOrderAudit.vue'], resolve)
      },
      meta: {
        title: '赠品订单额度审核'
      }
    },
    {
      name: 'memberMyGiftConfirm',
      path: '/repair/shopping/giftConfirm',
      component(resolve) {
        require(['../pages/memberCenter/personal/gift/giftConfirm.vue'], resolve)
      },
      meta: {
        title: '礼品领取'
      }
    }, {
      name: 'memberGrowUp',
      path: '/repair/member/center/per/growUp',
      component(resolve) {
        require(['../pages/memberCenter/personal/growUp/index.vue'], resolve)
      },
      meta: {
        title: '成长经历'
      }
    }, {
      name: 'memberStore',
      path: '/repair/member/center/per/store',
      component(resove) {
        require(['../pages/memberCenter/personal/store/storeInfo.vue'], resove)
      },
      meta: {
        title: '门店信息'
      }

    }, {
      name: 'memberStoreNature',
      path: '/repair/member/center/per/store/nature',
      component(resove) {
        require(['../pages/memberCenter/personal/store/nature.vue'], resove)
      },
      meta: {
        title: '门店性质'
      }

    }, {
      name: 'memberBusinessScope',
      path: '/repair/member/center/per/store/businessScope',
      component(resove) {
        require(['../pages/memberCenter/personal/store/businessScope.vue'], resove)
      },
      meta: {
        title: '业务范围'
      }

    },
    // {
    //   name: 'memberCollecter',
    //   path: '/repair/member/center/per/collection',
    //   component(resolve) {
    //     require(['../pages/memberCenter/personal/collection/collecter.vue'], resolve)
    //   },
    //   meta: {
    //     title: '我的收藏'
    //   }
    // },
    {
      name: 'memberCoupon',
      path: '/repair/member/center/per/coupon',
      component(resolve) {
        require(['../pages/memberCenter/personal/coupon/couponer.vue'], resolve)
      },
      meta: {
        title: '我的优惠券'
      }
    },
    {
      name: 'memberMedalCenter',
      path: '/repair/member/center/per/medal/medalCenter',
      component(resolve) {
        require(['../pages/memberCenter/personal/medal/medalCenter.vue'], resolve)
      },
      meta: {
        title: '勋章中心'
      }
    },
    {
      name: 'wallet',
      path: '/repair/member/center/per/medal/wallet',
      component(resolve) {
        require(['../pages/memberCenter/personal/wallet.vue'], resolve)
      },
      meta: {
        title: '钱包'
      }
    },
    {
      name: 'memberReward',
      path: '/repair/member/center/per/medal/reward',
      component(resolve) {
        require(['../pages/memberCenter/personal/medal/reward.vue'], resolve)
      },
      meta: {
        title: '明细与提现'
      }
    },
    {
      name: 'memberInfo',
      path: '/repair/member/center/per/medal/medalInfo',
      component(resolve) {
        require(['../pages/memberCenter/personal/medal/medalInfo.vue'], resolve)
      },
      meta: {
        title: '勋章中心'
      }
    },
    {
      name: 'memberRenew',
      path: '/repair/member/center/per/renew',
      component(resolve) {
        require(['../pages/memberCenter/personal/renew/index.vue'], resolve)
      },
      meta: {
        title: '会员续费'
      }
    }, {
      name: 'memberIntegral',
      path: '/repair/member/center/per/intergal/memberIntegral',
      component(resolve) {
        require(['../pages/memberCenter/personal/intergal/memberIntegral.vue'], resolve)
      },
      meta: {
        title: '我的积分'
      }
    }, {
      name: 'memberRenewSuccess',
      path: '/repair/member/center/per/renew/success',
      component(resolve) {
        require(['../pages/memberCenter/personal/address/addressExclusiveManager.vue'], resolve)
      },
      meta: {
        title: '认证续费'
      }
    }, {
      name: 'cyclopeIndex',
      path: '/repair/cycLopeDia/index',
      component(resolve) {
        require(['../pages/cyclopedia/index.vue'], resolve)
      },
      meta: {
        title: '电喷百科'
      }
    }, {
      name: 'circuitIndex',
      path: '/repair/circuitData/index',
      component(resolve) {
        require(['../pages/soso/circuitData/index.vue'], resolve)
      },
      meta: {
        title: '电路资料'
      }
    }, {
      name: 'circuitResult',
      path: '/repair/circuitData/result',
      component(resolve) {
        require(['../pages/soso/circuitData/result.vue'], resolve)
      },
      meta: {
        title: '电路资料'
      }
    }, {
      name: 'cyclopeResult',
      path: '/repair/cycLopeDia/result',
      component(resolve) {
        require(['../pages/cyclopedia/resultList.vue'], resolve)
      },
      meta: {
        title: '电喷百科'
      }
    },
    // {
    //   name: 'phoneLogin',
    //   path: '/repair/phoneLogin',
    //   component(resolve) {
    //     require(['../pages/memberCenter/phoneLogin.vue'], resolve)
    //   },
    //   meta: {
    //     title: '登录'
    //   }
    // },
    // {
    //   name: 'login',
    //   path: '/repair/login',
    //   component(resolve) {
    //     require(['../pages/memberCenter/login.vue'], resolve)
    //   },
    //   meta: {
    //     title: '登录'
    //   }
    // },
    // {
    //   name: 'loginOld',
    //   path: '/repair/loginOld',
    //   component(resolve) {
    //     require(['../pages/memberCenter/loginOld.vue'], resolve)
    //   },
    //   meta: {
    //     title: '手机号登录'
    //   }
    // },
    // {
    //   name: 'newLogin',
    //   path: '/repair/newLogin',
    //   component(resolve) {
    //     require(['../pages/memberCenter/newLogin.vue'], resolve)
    //   },
    //   meta: {
    //     title: '登录'
    //   }
    // },
    // {
    //   name: 'deal',
    //   path: '/repair/deal',
    //   component(resolve) {
    //     require(['../pages/common/deal.vue'], resolve)
    //   },
    //   meta: {
    //     title: '用户协议'
    //   }
    // },
    // {
    //   name: 'communityRight',
    //   path: '/repair/communityRight',
    //   component(resolve) {
    //     require(['../pages/common/communityRight.vue'], resolve)
    //   },
    //   meta: {
    //     title: '论坛社区管理制度'
    //   }
    // },
    // {
    //   name: 'personInfoRight',
    //   path: '/repair/personInfoRight',
    //   component(resolve) {
    //     require(['../pages/common/personInfoRight.vue'], resolve)
    //   },
    //   meta: {
    //     title: '个人信息保护政策'
    //   }
    // },
    // {
    //   name: 'noCallRight',
    //   path: '/repair/noCallRight',
    //   component(resolve) {
    //     require(['../pages/common/noCallRight.vue'], resolve)
    //   },
    //   meta: {
    //     title: '免电话营销服务承诺'
    //   }
    // },
    {
      name: 'orderPriceAdjustment',
      path: '/repair/orderPriceAdjustment',
      component(resolve) {
        require(['../pages/common/orderPriceAdjustment.vue'], resolve)
      },
      meta: {
        title: '订单调价审核'
      }
    },
    {
      path: '/repair/article/list',
      component(resolve) {
        require(['../pages/feed.vue'], resolve)
      },
      meta: {
        title: '卡修宝典'
      }
    },
    {
      path: '/repair/customerBoard',
      component(resolve) {
        require(['../pages/customerBoard.vue'], resolve)
      },
      meta: {
        title: '微客服'
      }
    }, {
      path: '/repair/common/messageList',
      component(resolve) {
        require(['../pages/messageBox/index.vue'], resolve)
      },
      meta: {
        title: '消息中心'
      }
    }, {
      path: '/repair/message/articleList',
      name: 'messageArticleList',
      component(resolve) {
        require(['../pages/messageBox/messageBoxTemplate/article.vue'], resolve)
      },
      meta: {
        title: '卡修宝典'
      }
    }, {
      path: '/repair/message/noticeList',
      name: 'messageNoticeList',
      component(resolve) {
        require(['../pages/messageBox/messageBoxTemplate/notice.vue'], resolve)
      },
      meta: {
        title: '卡修宝典'
      }
    }, {
      path: '/repair/message/helperList',
      name: 'messageHelperList',
      component(resolve) {
        require(['../pages/messageBox/messageBoxTemplate/helper.vue'], resolve)
      },
      meta: {
        title: '卡修宝典'
      }
    }, {
      name: 'shopping',
      path: '/repair/shopping/index',
      component(resolve) {
        require(['../pages/shopping/index.vue'], resolve)
      },
      meta: {
        title: '商 城'
      }
    },
    {
      name: 'yhqSearch',
      path: '/repair/shopping/yhqSearch',
      component(resolve) {
        require(['../pages/shopping/yhqSearch.vue'], resolve)
      },
      meta: {
        title: '优惠券商品'
      }
    },
    {
      name: 'topicDetail',
      path: '/repair/shopping/topicDetail',
      component(resolve) {
        require(['../pages/shopping/topicDetail.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'shoppingSearch',
      path: '/repair/shopping/search',
      component(resolve) {
        require(['../pages/shopping/shopsearch.vue'], resolve)
      },
      meta: {
        title: '搜索'
      }
    },
    {
      name: 'specialDetail',
      path: '/repair/shopping/SpecialDetail',
      component(resolve) {
        require(['../pages/shopping/SpecialDetails.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'productDetail',
      path: '/repair/shopping/detail',
      component(resolve) {
        require(['../pages/shopping/proDetail.vue'], resolve)
      },
      meta: {
        title: '商品详情'
      }
    },
    {
      name: 'notfound',
      path: '/repair/notfound',
      component(resolve) {
        require(['../pages/notfound.vue'], resolve)
      },
      meta: {
        title: '404'
      }
    }, {
      name: 'shoppingCart',
      path: '/repair/shopping/cart',
      component(resolve) {
        require(['../pages/shopping/cart.vue'], resolve)
      },
      meta: {
        title: '购物车'
      }
    }, {
      name: 'shoppingOrderPay',
      path: '/repair/business/pay/shoppingPay',
      component(resolve) {
        require(['../pages/shopping/orderPay.vue'], resolve)
      },
      meta: {
        title: '订单详情'
      }
    }, {
      name: 'shoppingBank',
      path: '/repair/shopping/bankTransfer',
      component(resolve) {
        require(['../pages/shopping/bankTransfer.vue'], resolve)
      },
      meta: {
        title: '银行转账'
      }
    }, {
      name: 'operationSuccess',
      path: '/repair/common/operationSuccess',
      component(resolve) {
        require(['../components/common/operationSuccess.vue'], resolve)
      },
      meta: {
        title: '银行转账'
      }
    }, {
      name: 'instalment',
      path: '/repair/shopping/instalment',
      component(resolve) {
        require(['../pages/shopping/instalment.vue'], resolve)
      },
      meta: {
        title: '分期支付'
      }
    },
    {
      name: 'productFeedback',
      path: '/repair/system/productFeedback/productFeedback',
      component(resolve) {
        require(['../pages/system/productFeedback/productFeedback.vue'], resolve)
      },
      meta: {
        title: '产品帮助与反馈'
      }
    },
    {
      name: 'oldFriend',
      path: '/repair/system/single/oldFriend',
      component(resolve) {
        require(['../pages/system/single/oldFriend.vue'], resolve)
      },
      meta: {
        title: '老友卡'
      }
    },
    {
      name: 'oldFriendSecond',
      path: '/repair/system/single/oldFriendSecond',
      component(resolve) {
        require(['../pages/system/single/oldFriendSecond.vue'], resolve)
      },
      meta: {
        title: '老友卡'
      }
    },
    {
      name: 'productFeedbackDetail',
      path: '/repair/system/productFeedback/productFeedbackDetail',
      component(resolve) {
        require(['../pages/system/productFeedback/productFeedbackDetail.vue'], resolve)
      },
      meta: {
        title: '小轨调查反馈'
      }
    },
    {
      name: 'questionDetail',
      path: '/repair/system/productFeedback/questionDetail',
      component(resolve) {
        require(['../pages/system/productFeedback/questionDetail.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'fmsSpecial', // fed流专题列表页
      path: '/repair/system/productFeedback/fmsSpecial',
      component(resolve) {
        require(['../pages/system/productFeedback/fmsSpecial.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'activeSignIndex',
      path: '/repair/system/activeSign/index',
      component(resolve) {
        require(['../pages/system/activeSign/index.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'activeSignIndex2',
      path: '/repair/system/activesign/index',
      component(resolve) {
        require(['../pages/system/activeSign/index.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'activeSignResult',
      path: '/repair/system/activeSign/result',
      component(resolve) {
        require(['../pages/system/activeSign/result.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'moreQuestion',
      path: '/repair/system/productFeedback/moreQuestion',
      component(resolve) {
        require(['../pages/system/productFeedback/moreQuestion.vue'], resolve)
      },
      meta: {
        title: '产品帮助与反馈'
      }
    }, {
      name: 'report',
      path: '/repair/system/report/index',
      component(resolve) {
        require(['../pages/system/report/index.vue'], resolve)
      },
      meta: {
        title: '报表'
      }
    }, {
      name: 'folderList',
      path: '/repair/system/report/folder/list',
      component(resolve) {
        require(['../pages/system/report/folderList.vue'], resolve)
      },
      meta: {
        title: '报表'
      }
    }, {
      name: 'reportResult',
      path: '/repair/system/report/result',
      component(resolve) {
        require(['../pages/system/report/reportResult.vue'], resolve)
      },
      meta: {
        title: '报表'
      }
    },
    {
      path: '/repair/shopping/product/detail',
      redirect: '/repair/shopping/detail'
    },
    {
      name: 'inforindex2',
      path: '/repair/soso/inforLoad/indx',
      redirect: '/repair/business/pay/indx1',
      component(resolve) {
        require(['../pages/soso/inforLoad/indx.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'activeVoting',
      path: '/repair/business/pay/activeVoting',
      component(resolve) {
        require(['../pages/system/activeVoting/index.vue'], resolve)
      },
      meta: {
        title: '助力上卡修宝典台历'
      }
    },
    {
      name: 'appSearch',
      path: '/repair/business/pay/appSearch',
      component(resolve) {
        require(['../pages/appSearch/index.vue'], resolve)
      },
      meta: {
        title: '资料查询'
      }
    },
    {
      name: 'picList',
      path: '/repair/business/pay/picList',
      component(resolve) {
        require(['../pages/appSearch/picList.vue'], resolve)
      },
      meta: {
        title: '资料图集'
      }
    },
    {
      name: 'picListAssist',
      path: '/repair/business/pay/picListAssist',
      component(resolve) {
        require(['../pages/appSearch/picListAssist.vue'], resolve)
      },
      meta: {
        title: '资料详情'
      }
    },
    {
      name: 'appSearchResult',
      path: '/repair/business/pay/appSearchResult',
      component(resolve) {
        require(['../pages/appSearch/result.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'appSearchResultNew',
      path: '/repair/searchRes',
      component(resolve) {
        require(['../pages/appSearch/resultNew.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'appSearchResultNewXny',
      path: '/repair/searchResXny',
      component(resolve) {
        require(['../pages/appSearch/resultNewXny.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'appSearchDetail',
      path: '/repair/business/pay/appSearchDetail',
      component(resolve) {
        require(['../pages/appSearch/detail.vue'], resolve)
      },
      meta: {
        title: '故障码详情'
      }
    },
    {
      name: 'intelligentMatchDetail',
      path: '/repair/business/pay/intelligentMatchDetail',
      component(resolve) {
        require(['../pages/appSearch/intelligentMatchDetail.vue'], resolve)
      },
      meta: {
        title: '智能匹配详情'
      }
    },
    {
      name: 'buyGroups',
      path: '/repair/business/pay/buyGroups',
      component(resolve) {
        require(['../pages/buyGroups/index.vue'], resolve)
      },
      meta: {
        title: '小轨拼团'
      }
    }, {
      name: 'inforindex',
      path: '/repair/business/pay/indx1',
      component(resolve) {
        require(['../pages/soso/inforLoad/indx.vue'], resolve)
      },
      meta: {
        title: '课程页面'
      }
    },
    {
      name: 'inforindex1',
      path: '/repair/business/pay/indx',
      component(resolve) {
        require(['../pages/soso/inforLoad1/indx.vue'], resolve)
      },
      meta: {
        title: '资料页面'
      }
    }, {
      name: 'inforResult',
      path: '/repair/business/pay/result',
      component(resolve) {
        require(['../pages/soso/inforLoad/result.vue'], resolve)
      },
      meta: {
        title: '课程搜索'
      }
    },
    {
      name: 'inforResult1',
      path: '/repair/business/pay/result1',
      component(resolve) {
        require(['../pages/soso/inforLoad1/result.vue'], resolve)
      },
      meta: {
        title: '资料搜索'
      }
    }, {
      name: 'video',
      path: '/repair/pdfvideo/video',
      component(resolve) {
        require(['../components/pdfvideo/video.vue'], resolve)
      },
      meta: {
        title: '视频展示'
      }
    }, {
      name: 'failureCollect',
      path: '/repair/failureCase/failureCollect',
      component(resolve) {
        require(['../pages/failureCase/failureCollect.vue'], resolve)
      },
      meta: {
        title: '故障案例收集'
      }
    },
    {
      path: '/repair/redEnvelopes/index',
      name: 'redEnvelopes',
      component(resolve) {
        require(['../pages/system/redEnvelopes/index.vue'], resolve)
      },
      meta: {
        title: '瓜分100万'
      }
    },
    {
      path: '/repair/home',
      name: 'fms',
      component(resolve) {
        require(['../pages/system/fms.vue'], resolve)
      },
      meta: {
        title: '卡修宝典',
        keepAlive: true
      }
    },
    {
      path: '/repair/redEnvelopes/redEnvelopesSecond',
      name: 'redEnvelopesSecond',
      component(resolve) {
        require(['../pages/system/redEnvelopes/second.vue'], resolve)
      },
      meta: {
        title: '瓜分100万'
      }
    },
    {
      path: '/repair/business/pay/redFinal',
      name: 'redFinal',
      component(resolve) {
        require(['../pages/system/redEnvelopes/redFinal.vue'], resolve)
      },
      meta: {
        title: '瓜分100万'
      }
    },
    {
      path: '/repair/operationPage/:documentId',
      name: 'operationPage',
      component(resolve) {
        require(['../pages/singlePage/operationPage.vue'], resolve)
      },
      meta: {
        title: '文章详情'
      }
    },
    {
      path: '/repair/appointmentPage',
      name: 'appointmentPage',
      component(resolve) {
        require(['../pages/singlePage/appointment/appointment.vue'], resolve)
      },
      meta: {
        title: '活动预约'
      }
    },
    {
      path: '/repair/appointedPage',
      name: 'appointedPage',
      component(resolve) {
        require(['../pages/singlePage/appointment/appointed.vue'], resolve)
      },
      meta: {
        title: '活动预约'
      }
    },

    {
      path: '/repair/courseRecommend',
      name: 'courseRecommend',
      component(resolve) {
        require(['../pages/singlePage/courseRecommend.vue'], resolve)
      },
      meta: {
        title: '课程评价'
      }
    },
    {
      path: '/repair/courseList',
      name: 'courseList',
      component(resolve) {
        require(['../pages/singlePage/courseList.vue'], resolve)
      },
      meta: {
        title: '课程评价'
      }
    },
    {
      path: '/repair/upload',
      name: 'upload',
      component(resolve) {
        require(['../pages/upload.vue'], resolve)
      },
      meta: {
        title: '上传文件'
      }
    },
    {
      path: '/repair/questionnaire/index',
      name: 'questionnaire',
      component(resolve) {
        require(['../pages/questionnaire/index.vue'], resolve)
      },
      meta: {
        title: '卡修宝典'
      }
    },

    /* 新商城*/
    // {
    //   name: 'newShopping',
    //   path: '/repair/shopping/newIndex',
    //   component(resolve) {
    //     require(['../pages/newShopping/index.vue'], resolve)
    //   },
    //   meta: {
    //     title: '商城'
    //   }
    // },
    // {
    //   name: 'newSpecialDetail',
    //   path: '/repair/shopping/newSpecialDetail',
    //   component(resolve) {
    //     require(['../pages/newShopping/SpecialDetails.vue'], resolve)
    //   },
    //   meta: {
    //     title: '分类'
    //   }
    // },
    // {
    //   name: 'newShoppingCart',
    //   path: '/repair/shopping/newCart',
    //   component(resolve) {
    //     require(['../pages/newShopping/cart.vue'], resolve)
    //   },
    //   meta: {
    //     title: '购物车'
    //   }
    // },
    // {
    //   name: 'myShop',
    //   path: '/repair/shopping/myShop',
    //   component(resolve) {
    //     require(['../pages/newShopping/myShop.vue'], resolve)
    //   },
    //   meta: {
    //     title: '我的'
    //   }
    // },
    // {
    //   name: 'newProductDetail',
    //   path: '/repair/shopping/newDetail',
    //   component(resolve) {
    //     require(['../pages/newShopping/proDetail.vue'], resolve)
    //   },
    //   meta: {
    //     title: '商品详情'
    //   }
    // },
    // {
    //   name: 'newShoppingSearch',
    //   path: '/repair/shopping/newSearch',
    //   component(resolve) {
    //     require(['../pages/newShopping/shopsearch.vue'], resolve)
    //   },
    //   meta: {
    //     title: '搜索'
    //   }
    // },
    {
      name: 'crmSaleInfo',
      path: '/repair/crm/saleInfo',
      component(resolve) {
        require(['../pages/crm/crmSaleInfo.vue'], resolve)
      },
      meta: {
        title: '地推人员信息'
      }
    },
    {
      name: 'grabOrder',
      path: '/repair/crm/grabOrder',
      component(resolve) {
        require(['../pages/crm/grabOrder.vue'], resolve)
      },
      meta: {
        title: '抢单'
      }
    },
    {
      name: 'messageTake', // 消息订阅
      path: '/repair/messageTake/index',
      component(resolve) {
        require(['../pages/messageTake/index.vue'], resolve)
      },
      meta: {
        title: '消息订阅'
      }

    },
    {
      name: 'messageTakeSecond', // 消息订阅二级页面
      path: '/repair/messageTake/secondLevel',
      component(resolve) {
        require(['../pages/messageTake/secondLevel.vue'], resolve)
      },
      meta: {
        title: '消息订阅'
      }

    },
    {
      name: 'checkStep', // 排查步骤
      path: '/repair/gzm/checkStep',
      component(resolve) {
        require(['../pages/appSearch/checkStepsCont.vue'], resolve)
      },
      meta: {
        title: '排查步骤'
      }

    },
    {
      name: 'examAndclass', // 考试和班课
      path: '/repair/examAndclass/index',
      component(resolve) {
        require(['../pages/examAndClass/index.vue'], resolve)
      },
      meta: {
        title: '卡修宝典'
      }

    },

    {
      name: 'reNewSalePerson', // 以旧换新_销售端
      path: '/repair/reNew/salesPerson',
      component(resolve) {
        require(['../pages/reNew/salesPerson.vue'], resolve)
      },
      meta: {
        title: '以旧换新申请'
      }

    },
    {
      name: 'reNewSelectGood', // 以旧换新_销售选择商品
      path: '/repair/reNew/selectGood',
      component(resolve) {
        require(['../pages/reNew/selectGood.vue'], resolve)
      },
      meta: {
        title: '选择商品'
      }

    },
    {
      name: 'reNewMyApplication', // 以旧换新_销售的申请记录
      path: '/repair/reNew/MyApplication',
      component(resolve) {
        require(['../pages/reNew/myApplication.vue'], resolve)
      },
      meta: {
        title: '我的申请'
      }

    },
    {
      name: 'reNewResult', // 以旧换新_销售查询结果
      path: '/repair/reNew/reNewResult',
      component(resolve) {
        require(['../pages/reNew/reNewResult.vue'], resolve)
      },
      meta: {
        title: '以旧换新申请'
      }

    }, {
      name: 'reNewClient', // 以旧换新_客户端
      path: '/repair/reNew/client',
      component(resolve) {
        require(['../pages/reNew/client.vue'], resolve)
      },
      meta: {
        title: '以旧换新'
      }

    },
    {
      name: 'groupInvite', // 活动-组队抽会员
      path: '/repair/singlepage/group_members',
      component(resolve) {
        require(['../pages/singlePage/group_members/invite.vue'], resolve)
      },
      meta: {
        title: '组队抽奖'
      }
    },
    {
      name: 'groupRecord', // 活动-组队抽会员-抽奖记录页
      path: '/repair/singlepage/group_members/record',
      component(resolve) {
        require(['../pages/singlePage/group_members/record.vue'], resolve)
      },
      meta: {
        title: '组队抽奖记录'
      }
    },
    {
      name: 'skillCertificate', // 技能证书查询首页
      path: '/repair/singlepage/certificate',
      component(resolve) {
        require(['../pages/singlePage/certificate/index.vue'], resolve)
      },
      meta: {
        title: '技能证书'
      }
    },
    {
      name: 'certificateList', // 技能证书查询列表
      path: '/repair/singlepage/certificate/list',
      component(resolve) {
        require(['../pages/singlePage/certificate/list.vue'], resolve)
      },
      meta: {
        title: '证书查询'
      }
    },
    {
      name: 'carRepair', // 5.1.0新增修车页面
      path: '/repair/carRepair',
      component(resolve) {
        require(['../pages/system/carRepair.vue'], resolve)
      },
      meta: {
        title: '修车'
      }
    },
    {
      name: 'corpus', // 资料大全目录页
      path: '/repair/Data',
      component(resolve) {
        require(['../pages/system/corpus.vue'], resolve)
      },
      meta: {
        title: '资料大全'
      }
    },
    {
      path: '*',
      // redirect: '/repair/datum/datumSearch?checkIndex=0'
      // redirect: '/repair/faultCode/index'
      // redirect: '/repair/lectureRoom'
      // redirect: '/repair/member/center'
      // redirect: '/repair/soso/universal'
      // redirect: '/repair/index'
      // redirect: '/repair/home'
      redirect: '/repair/courseListPlate'
    // redirect: '/repair/login'

    },
    {
      name: 'circuitDiagram2', // 产品库2.0-电路图
      path: '/repair/library/circuitDiagram2/:pageType/:spid',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/index.vue'], resolve)
      },
      meta: {
        title: '电路图'
      }
    },
    {
      name: 'ecuIndex', // 产品库2.0-电路图 - ECU
      path: '/repair/library/circuitDiagram2/ecu/:pageType/:spid',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/ecu/index.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'ecuIndexBrand', // 产品库2.0-电路图 - ECU
      path: '/repair/library/circuitDiagram2/brand/:pageType/:spid/:moudle/:pathNo',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/ecu/brand.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'ecuMaterial', // 产品库2.0-电路图 - ECU
      path: '/repair/library/circuitDiagram2/ecuMaterial/:pageType/:spid/:moudle/:pathNo',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/ecu/ecuMaterial.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'vehicle', // 产品库2.0-电路图 - 整车电路图
      path: '/repair/library/circuitDiagram2/vehicle/:pageType/:spid',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/vehicle/index.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'vehicleBrand', // 产品库2.0-电路图 - 整车电路图
      path: '/repair/library/circuitDiagram2/vehicleBrand/:pageType/:spid/:moudle/:pathNo',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/vehicle/vehicleBrand.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'vehicleMaterial', // 产品库2.0-电路图 - 整车电路图
      path: '/repair/library/circuitDiagram2/vehicleMaterial/:pageType/:spid/:moudle/:pathNo',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/vehicle/vehicleMaterial.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'engineeringMachinery', // 产品库2.0-电路图 - 整车电路图
      path: '/repair/library/circuitDiagram2/engineeringMachinery/:pageType/:spid',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/engineeringMachinery/index.vue'], resolve)
      },
      meta: {
        title: '工程机械电路图'
      }
    },
    {
      name: 'engineeringMaterial', // 产品库2.0-电路图 - 工程机械电路图
      path: '/repair/library/circuitDiagram2/engineeringMachinery/engineeringMaterial/:pageType/:spid/:moudle/:pathNo',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/engineeringMachinery/engineeringMaterial.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'commonResult', // 产品库2.0 通用资料结果页/:pageType/:spid/:moudle/:pathNo
      path: '/repair/library/circuitDiagram2/commonResult/:pageType/:spid/:moudle/:pathNo',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/commonResult/index.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'engine', // 产品库2.0-发动机资料
      path: '/repair/library/circuitDiagram2/engine',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/engine/index.vue'], resolve)
      },
      meta: {
        title: '发动机资料'
      }
    },
    {
      name: 'engineNode', // 产品库2.0-发动机资料
      path: '/repair/library/circuitDiagram2/engineNode',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/engine/engineNode.vue'], resolve)
      },
      meta: {
        title: '发动机资料'
      }
    },
    {
      name: 'engineNode1', // 产品库2.0-发动机资料
      path: '/repair/library/circuitDiagram2/engineNode1',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/engine/engineNode1.vue'], resolve)
      },
      meta: {
        title: '发动机资料'
      }
    },
    {
      name: 'engineResult', // 产品库2.0-发动机资料
      path: '/repair/library/circuitDiagram2/engineResult',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/engine/engineResult.vue'], resolve)
      },
      meta: {
        title: '发动机资料'
      }
    },
    {
      name: 'ABS2', // 产品库2.0-ABS
      path: '/repair/library/circuitDiagram2/abs',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/abs/index.vue'], resolve)
      },
      meta: {
        title: 'ABS电路图'
      }
    },
    {
      name: 'ABSResult', // 产品库2.0-ABS
      path: '/repair/library/circuitDiagram2/ABSResult',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/abs/ABSResult.vue'], resolve)
      },
      meta: {
        title: 'ABS电路图'
      }
    },
    {
      name: 'sensor', // 产品库2.0-传感器/执行器
      path: '/repair/library/circuitDiagram2/sensor',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/sensor/index.vue'], resolve)
      },
      meta: {
        title: '传感器/执行器'
      }
    },
    {
      name: 'sensorResult', // 产品库2.0-传感器/执行器
      path: '/repair/library/circuitDiagram2/sensorResult',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/sensor/sensorResult.vue'], resolve)
      },
      meta: {
        title: '传感器/执行器'
      }
    },
    {
      name: 'sensorPinDefinition', // 产品库2.0-针脚传感器定义
      path: '/repair/library/circuitDiagram2/sensorPinDefinition',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/sensorPinDefinition/index.vue'], resolve)
      },
      meta: {
        title: '传感器针脚定义'
      }
    },
    {
      name: 'sensorPinResult', // 产品库2.0-针脚传感器定义
      path: '/repair/library/circuitDiagram2/sensorPinResult',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/sensorPinDefinition/sensorPinResult.vue'], resolve)
      },
      meta: {
        title: '传感器针脚定义'
      }
    },
    {
      name: 'carModule2', // 产品库2.0-车身模块电路图
      path: '/repair/library/circuitDiagram2/carModule2',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/carModule2/index.vue'], resolve)
      },
      meta: {
        title: '车身模块电路图'
      }
    },
    {
      name: 'carNode', // 产品库2.0-车身模块电路图
      path: '/repair/library/circuitDiagram2/carNode',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/carModule2/carNode.vue'], resolve)
      },
      meta: {
        title: '车身模块电路图'
      }
    },
    {
      name: 'carNode2', // 产品库2.0-车身模块电路图
      path: '/repair/library/circuitDiagram2/carNode2',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/carModule2/carNode2.vue'], resolve)
      },
      meta: {
        title: '车身模块电路图'
      }
    },
    {
      name: 'carResult', // 产品库2.0-车身模块电路图
      path: '/repair/library/circuitDiagram2/carResult',
      component(resolve) {
        require(['../pages/dataLibrary/circuitDiagram2/carModule2/carResult.vue'], resolve)
      },
      meta: {
        title: '车身模块电路图'
      }
    },
    {
      name: 'efiEncyclop', // 电喷百科 - 首页
      path: '/repair/library/efiEncyclop/index',
      component(resolve) {
        require(['../pages/dataLibrary/efiEncyclop/index.vue'], resolve)
      },
      meta: {
        title: '电喷百科'
      }
    },
    {
      name: 'efiEncyClassDetail', // 电喷百科 - 分类详情页
      path: '/repair/library/efiEncyclop/classDetail',
      component(resolve) {
        require(['../pages/dataLibrary/efiEncyclop/classDetail.vue'], resolve)
      },
      meta: {
        title: '电喷百科'
      }
    },
    {
      name: 'efiEncyDetail', // 电喷百科 - 词条详情页
      path: '/repair/library/efiEncyclop/encyDetail',
      component(resolve) {
        require(['../pages/dataLibrary/efiEncyclop/encyDetail.vue'], resolve)
      },
      meta: {
        title: '词条详情'
      }
    },
    {
      name: 'faultCode2',
      path: '/repair/library/faultCode2', // 故障码查询
      component(resolve) {
        require(['../pages/dataLibrary/faultCode2/index.vue'], resolve)
      },
      meta: {
        title: '故障码'
      }
    },
    {
      name: 'faultCodeXny',
      path: '/repair/library/faultCodeXny', // 故障码查询
      component(resolve) {
        require(['../pages/dataLibrary/faultCodeXny/index.vue'], resolve)
      },
      meta: {
        title: '新能源故障码'
      }
    },
    {
      name: 'reasult',
      path: '/repair/library/faultCode2/reasult', // 故障码查询结果
      component(resolve) {
        require(['../pages/dataLibrary/faultCode2/reasult.vue'], resolve)
      },
      meta: {
        title: '故障码查询'
      }
    },
    {
      name: 'faultCodeDesc',
      path: '/repair/library/faultCode2/faultCodeDesc', // 故障码查询结果
      component(resolve) {
        require(['../pages/dataLibrary/faultCode2/faultCodeDesc.vue'], resolve)
      },
      meta: {
        title: '故障码详情'
      }
    },
    {
      name: 'faultCodeDescXny',
      path: '/repair/library/faultCodeXny/faultCodeDesc', // 故障码查询结果
      component(resolve) {
        require(['../pages/dataLibrary/faultCodeXny/faultCodeDesc.vue'], resolve)
      },
      meta: {
        title: '故障码详情'
      }
    },
    {
      name: 'questionsAndAnswers',
      path: '/repair/questionsAndAnswers', // 问答
      component(resolve) {
        require(['../pages/questionsAndAnswers/index.vue'], resolve)
      },
      meta: {
        title: '问答'
      }
    },
    {
      name: 'allProblems',
      path: '/repair/questionsAndAnswers/allProblems', // 问答
      component(resolve) {
        require(['../pages/questionsAndAnswers/allProblems.vue'], resolve)
      },
      meta: {
        title: '全部问题'
      }
    },
    {
      name: 'questionDetails',
      path: '/repair/questionsAndAnswers/questionDetails', // 问答
      component(resolve) {
        require(['../pages/questionsAndAnswers/questionDetails.vue'], resolve)
      },
      meta: {
        title: '问题详情'
      }
    },
    {
      name: 'orderDetails',
      path: '/repair/questionsAndAnswers/orderDetails', // 问答
      component(resolve) {
        require(['../pages/questionsAndAnswers/orderDetails.vue'], resolve)
      },
      meta: {
        title: '接单'
      }
    },
    {
      name: 'conversation',
      path: '/repair/questionsAndAnswers/conversation', // 问答
      component(resolve) {
        require(['../pages/questionsAndAnswers/conversation.vue'], resolve)
      },
      meta: {
        title: '会话'
      }
    },
    {
      name: 'openOrderSettings',
      path: '/repair/questionsOrAnswers/openOrderSettings', // 问答
      component(resolve) {
        require(['../pages/questionsOrAnswers/openOrderSettings.vue'], resolve)
      },
      meta: {
        title: '接单设置'
      }
    },
    {
      name: 'QAndASettings',
      path: '/repair/questionsAndAnswers/QAndASettings', // 问答
      component(resolve) {
        require(['../pages/questionsAndAnswers/QAndASettings.vue'], resolve)
      },
      meta: {
        title: '问答设置'
      }
    },
    {
      name: 'putQuestion0',
      path: '/repair/questionsAndAnswers/putQuestion0', // 问答
      component(resolve) {
        require(['../pages/questionsAndAnswers/putQuestion.vue'], resolve)
      },
      meta: {
        title: '提问'
      }
    },
    {
      name: 'putQuestion5',
      path: '/repair/questionsAndAnswers/putQuestion5', // 问答
      component(resolve) {
        require(['../pages/questionsAndAnswers/putQuestion5.vue'], resolve)
      },
      meta: {
        title: '提问'
      }
    },
    {
      name: 'communicationMethod',
      path: '/repair/shopping/communicationMethod', // 问答
      component(resolve) {
        require(['../pages/questionsAndAnswers/communicationMethod.vue'], resolve)
      },
      meta: {
        title: '选择沟通方式'
      }
    },
    {
      name: 'questionProgress',
      path: '/repair/shopping/questionProgress', // 问答
      component(resolve) {
        require(['../pages/questionsAndAnswers/questionProgress.vue'], resolve)
      },
      meta: {
        title: '问题已创建'
      }
    },
    {
      name: 'acceleratorCard',
      path: '/repair/questionsAndAnswers/acceleratorCard', // 问答
      component(resolve) {
        require(['../pages/questionsAndAnswers/acceleratorCard.vue'], resolve)
      },
      meta: {
        title: '领取加速卡'
      }
    },
    {
      name: 'qaAssistant',
      path: '/repair/questionsAndAnswers/qaAssistant', // 问答
      component(resolve) {
        require(['../pages/questionsAndAnswers/qaAssistant.vue'], resolve)
      },
      meta: {
        title: '问答小助手'
      }
    },
    {
      name: 'problemSquare',
      path: '/repair/questionsAndAnswers/problemSquare', // 问答
      component(resolve) {
        require(['../pages/questionsAndAnswers/problemSquare.vue'], resolve)
      },
      meta: {
        title: '问题广场'
      }
    },
    {
      name: 'buyUrea', // 购买尿素泵娴熟
      path: '/repair/shopping/buyUrea',
      component(resolve) {
        require(['../pages/shopping/buyUrea.vue'], resolve)
      },
      meta: {
        title: '购买尿素泵'
      }
    },
    {
      name: 'scanCodeExchange', // 扫码送权益
      path: '/repair/shopping/scanCodeExchange',
      component(resolve) {
        require(['../pages/shopping/scanCodeExchange.vue'], resolve)
      },
      meta: {
        title: '卡修宝典-权益兑换'
      }
    },
    {
      name: 'scanCodeDetail', // 扫码送权益详情页
      path: '/repair/shopping/scanCodeDetail',
      component(resolve) {
        require(['../pages/shopping/scanCodeDetail.vue'], resolve)
      },
      meta: {
        title: '卡修宝典-权益兑换'
      }
    },
    {
      name: 'exchangeList', // 我的权益列表页
      path: '/repair/shopping/exchangeList',
      component(resolve) {
        require(['../pages/shopping/exchangeList.vue'], resolve)
      },
      meta: {
        title: '我的权益'
      }
    },
    {
      name: 'exchangeDetail', // 我的权益详情页
      path: '/repair/shopping/exchangeDetail',
      component(resolve) {
        require(['../pages/shopping/exchangeDetail.vue'], resolve)
      },
      meta: {
        title: '我的权益'
      }
    },
    {
      name: 'careFreePartnerAsk',
      path: '/repair/careFreePartner/ask',
      component(resolve) {
        require(['../pages/careFreePartner/ask.vue'], resolve)
      },
      meta: {
        title: '无忧伙伴提问'
      }
    },
    {
      name: 'careFreePartnerAsk',
      path: '/repair/careFreePartner/order',
      component(resolve) {
        require(['../pages/careFreePartner/order.vue'], resolve)
      },
      meta: {
        title: '无忧伙伴接单'
      }
    },
    {
      name: 'realNameProof', // 实名认证
      path: '/repair/common/realNameProof',
      component(resolve) {
        require(['../pages/common/realNameProof.vue'], resolve)
      },
      meta: {
        title: '实名认证'
      }
    },
    {
      name: 'directionJump', // 定向跳转
      path: '/repair/url',
      component(resolve) {
        require(['../pages/common/directionJump.vue'], resolve)
      },
      meta: {
        title: '卡修宝典'
      }
    },
    {
      name: 'meterLampList',
      path: '/repair/meterLamp/list',
      component(resolve) {
        require(['../pages/panelLight/index.vue'], resolve)
      },
      meta: {
        title: '故障灯'
      }
    },
    {
      name: 'panelLightSearch',
      path: '/repair/panelLight/search',
      component(resolve) {
        require(['../pages/panelLight/search.vue'], resolve)
      },
      meta: {
        title: '故障灯'
      }
    },
    {
      name: 'panelLightDetail',
      path: '/repair/panelLight/share',
      component(resolve) {
        require(['../pages/panelLight/shareDetail.vue'], resolve)
      },
      meta: {
        title: '故障灯详情'
      }
    },
    {
      name: 'userAgreementZDNS', // 诊断能手
      path: '/repair/userAgreementZDNS',
      component(resolve) {
        require(['../pages/common/userAgreementZDNS.vue'], resolve)
      },
      meta: {
        title: '用户服务协议'
      }
    },
    {
      name: 'informationProtectionZDNS', // 诊断能手
      path: '/repair/informationProtectionZDNS',
      component(resolve) {
        require(['../pages/common/informationProtectionZDNS.vue'], resolve)
      },
      meta: {
        title: '个人信息保护政策'
      }
    },
    {
      name: 'IQAReverseDirection', // IQA逆向
      path: '/repair/IQA/IQAReverseDirection',
      component(resolve) {
        require(['../pages/dataLibrary/IQA/IQAReverseDirection.vue'], resolve)
      },
      meta: {
        title: 'IQA逆向'
      }
    },
    {
      name: 'memberRecord', // 会员记录
      path: '/repair/member/memberRecord',
      component(resolve) {
        require(['../pages/memberCenter/memberRecord/memberRecord.vue'], resolve)
      },
      meta: {
        title: '会员记录'
      }
    },
    {
      name: 'userAgreementJGZ', // 金刚钻
      path: '/repair/userAgreementJGZ',
      component(resolve) {
        require(['../pages/common/userAgreementJGZ.vue'], resolve)
      },
      meta: {
        title: '用户服务协议'
      }
    },
    {
      name: 'informationProtectionJGZ', // 金刚钻
      path: '/repair/informationProtectionJGZ',
      component(resolve) {
        require(['../pages/common/informationProtectionJGZ.vue'], resolve)
      },
      meta: {
        title: '个人信息保护政策'
      }
    },
    {
      name: 'identification',
      path: '/repair/identification',
      component(resolve) {
        require(['../pages/activityPage/identification.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'productDetailLive', // 商品详情页(直播带货专用)
      path: '/repair/mall/productDetail',
      component(resolve) {
        require(['../pages/mall/productDetail.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'confirmOrder', // 确认订单页(直播带货专用)
      path: '/repair/mall/confirmOrder',
      component(resolve) {
        require(['../pages/mall/confirmOrder.vue'], resolve)
      },
      meta: {
        title: ''
      }
    },
    {
      name: 'tickCoupons', // 领券中心
      path: '/repair/mall/tickCoupons',
      component(resolve) {
        require(['../pages/mall/tickCoupons.vue'], resolve)
      },
      meta: {
        title: '领券中心'
      }
    },
    {
      name: 'kxyCoin', // 卡修币
      path: '/repair/personal/kxyCoin',
      component(resolve) {
        require(['../pages/memberCenter/kxCoin/index.vue'], resolve)
      },
      meta: {
        title: '卡修币'
      }
    },
    {
      name: 'kxyCoinList', // 卡修币收支明细
      path: '/repair/personal/kxyCoinList',
      component(resolve) {
        require(['../pages/memberCenter/kxCoin/list.vue'], resolve)
      },
      meta: {
        title: '收支明细'
      }
    },
    {
      name: 'myKxyCoin', // 卡修币收支明细
      path: '/repair/personal/myKxyCoin',
      component(resolve) {
        require(['../pages/memberCenter/kxCoin/myCoin.vue'], resolve)
      },
      meta: {
        title: '我的卡修币'
      }
    },
    {
      name: 'circuit', // 电路图图纸资料
      path: '/repair/circuit',
      component(resolve) {
        require(['../pages/circuit/index.vue'], resolve)
      },
      meta: {
        title: '图纸资料'
      }
    },
    {
      name: 'circuitList', // 电路图图纸资料
      path: '/repair/circuit/list',
      component(resolve) {
        require(['../pages/circuit/list.vue'], resolve)
      },
      meta: {
        title: '图纸资料列表'
      }
    },
    {
      name: 'circuit/search', // 电路图图纸资料
      path: '/repair/circuit/search',
      component(resolve) {
        require(['../pages/circuit/search.vue'], resolve)
      },
      meta: {
        title: '图纸资料搜索'
      }
    },
    {
      name: 'circuit/searchAll', // 电路图图纸资料
      path: '/repair/circuit/searchAll',
      component(resolve) {
        require(['../pages/circuit/searchAll.vue'], resolve)
      },
      meta: {
        title: '图纸资料搜索'
      }
    },
    {
      name: 'circuit', // 电路图图纸资料
      path: '/repair/circuit/detail',
      component(resolve) {
        require(['../pages/circuit/detail.vue'], resolve)
      },
      meta: {
        title: '图纸资料详情'
      }
    },
    {
      name: 'kaxiubaodian', // 电路图图纸资料
      path: '/kaxiubaodian',
      component(resolve) {
        require(['../pages/appdown/appdown.vue'], resolve)
      },
      meta: {
        title: '卡修宝典'
      }
    },
    {
      name: 'alert', // 电路图图纸资料
      path: '/alert/alert',
      component(resolve) {
        require(['../pages/alert/alert.vue'], resolve)
      },
      meta: {
        title: '卡修宝典'
      }
    },
    {
      name: 'fileView', // 电路图图纸资料
      path: '/fileView/fileView',
      component(resolve) {
        require(['../pages/fileView/fileView.vue'], resolve)
      },
      meta: {
        title: '卡修宝典'
      }
    },
    {
      name: 'fileViewAssist', // 电路图图纸资料
      path: '/fileView/fileViewAssist',
      component(resolve) {
        require(['../pages/fileView/fileViewAssist.vue'], resolve)
      },
      meta: {
        title: '卡修宝典'
      }
    },
    {
      name: 'exportCircuit', // 电路图图纸资料
      path: '/exportCircuit/exportCircuit',
      component(resolve) {
        require(['../pages/exportCircuit/exportCircuit.vue'], resolve)
      },
      meta: {
        title: '卡修宝典'
      }
    },
    {
      name: 'dataStream', // 标准数据流
      path: '/dataStream/dataStream',
      component(resolve) {
        require(['../pages/dataStream/dataStream.vue'], resolve)
      },
      meta: {
        title: '标准数据流'
      }
    },
    {
      name: 'vipBuy', // 会员购买
      path: '/vipBuy/vipBuy',
      component(resolve) {
        require(['../pages/vipBuy/vipBuy.vue'], resolve)
      },
      meta: {
        title: '会员购买'
      }
    },
    {
      name: 'richText', // 会员购买
      path: '/richText/richText',
      component(resolve) {
        require(['../pages/richText/richText.vue'], resolve)
      },
      meta: {
        title: '会员购买'
      }
    },
    {
      name: 'richTextNew', // 会员购买
      path: '/richTextNew/richText',
      component(resolve) {
        require(['../pages/richTextNew/richText.vue'], resolve)
      },
      meta: {
        title: '使用说明'
      }
    },
    {
      name: 'myCollect', // 会员购买
      path: '/myCollect/myCollect',
      component(resolve) {
        require(['../pages/myCollect/myCollect.vue'], resolve)
      },
      meta: {
        title: '我的收藏'
      }
    },
    {
      name: 'dataStreamAnalysis',
      path: '/dataStreamAnalysis/dataStreamAnalysis',
      component(resolve) {
        require(['../pages/dataStreamAnalysis/dataStreamAnalysis.vue'], resolve)
      },
      meta: {
        title: '数据流智能分析'
      }
    },
    {
      name: 'ECUEncryptionSearch',
      path: '/ECUEncryptionSearch/ECUEncryptionSearch',
      component(resolve) {
        require(['../pages/ECUEncryptionSearch/ECUEncryptionSearch.vue'], resolve)
      },
      meta: {
        title: 'ECU加密查询'
      }
    },
    {
      name: 'EUCResult',
      path: '/ECUEncryptionSearch/EUCResult',
      component(resolve) {
        require(['../pages/ECUEncryptionSearch/EUCResult.vue'], resolve)
      },
      meta: {
        title: 'ECU加密查询'
      }
    },
    {
      name: 'fuelInjectorSearch',
      path: '/fuelInjectorSearch/fuelInjectorSearch',
      component(resolve) {
        require(['../pages/fuelInjectorSearch/fuelInjectorSearch.vue'], resolve)
      },
      meta: {
        title: '喷油器行程查询'
      }
    },
    {
      name: 'fuelInjectorResult',
      path: '/fuelInjectorSearch/fuelInjectorResult',
      component(resolve) {
        require(['../pages/fuelInjectorSearch/fuelInjectorResult.vue'], resolve)
      },
      meta: {
        title: '喷油器行程查询'
      }
    },
    {
      name: 'richTextID',
      path: '/richTextID/richTextID',
      component(resolve) {
        require(['../pages/richTextID/richText.vue'], resolve)
      },
      meta: {
        title: '隐私政策'
      }
    },
    {
      name: 'productMatching',
      path: '/productMatching/productMatching',
      component(resolve) {
        require(['../pages/productMatching/productMatching.vue'], resolve)
      },
      meta: {
        title: '产品配套'
      }
    },
    {
      name: 'brandInfo',
      path: '/productMatching/brandInfo',
      component(resolve) {
        require(['../pages/productMatching/brandInfo.vue'], resolve)
      },
      meta: {
        title: '产品配套'
      }
    },
    {
      name: 'modelInfo',
      path: '/productMatching/modelInfo',
      component(resolve) {
        require(['../pages/productMatching/modelInfo.vue'], resolve)
      },
      meta: {
        title: '产品配套'
      }
    },
    {
      name: 'secondaryData',
      path: '/secondaryData/secondaryData',
      component(resolve) {
        require(['../pages/secondaryData/secondaryData.vue'], resolve)
      },
      meta: {
        title: '资料'
      }
    },
    {
      name: 'secondList',
      path: '/secondaryData/secondList',
      component(resolve) {
        require(['../pages/secondaryData/secondList.vue'], resolve)
      },
      meta: {
        title: '资料'
      }
    },
    {
      name: 'infoList',
      path: '/secondaryData/infoList',
      component(resolve) {
        require(['../pages/secondaryData/infoList.vue'], resolve)
      },
      meta: {
        title: '资料'
      }
    },
    {
      name: 'downloadFile',
      path: '/downloadFile/downloadFile',
      component(resolve) {
        require(['../pages/downloadFile/downloadFile.vue'], resolve)
      },
      meta: {
        title: '下载资料'
      }
    }
  ]
})
